<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-monitoramento
      :acesso="acesso"
      monitoramento="perfil"
      :titulo="componente ? componente.titulo : ''"
    >
      <template v-slot:body>
        <v-col
          v-if="componente"
          centered
          cols="12"
          no-gutters
        >
          <keep-alive>
            <component :is="componente.nome" />
          </keep-alive>
        </v-col>
      </template>
    </app-monitoramento>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppMonitoramento from '@/components/core/AppMonitoramento';
import FiltroBuscaPerfil from '@/views/monitoramento/perfil/FiltroBuscaPerfil';
import RelatorioGerencialPerfil from '@/views/monitoramento/perfil/RelatorioGerencialPerfil';

export default {
  name: 'MonitoramentoPerfil',

  components: { AppMonitoramento, FiltroBuscaPerfil, RelatorioGerencialPerfil },

  data() {
    return {
      componente: null,
    };
  },

  computed: {
    ...mapState({
      isTutorialFiltroBuscaExibido: (state) => state.tutorial.dados.monitoramentoPerfilFiltrosBusca,
      isTutorialRelatoriosGerenciaisExibido: (state) => state.tutorial.dados.monitoramentoPerfilRelatoriosGerenciais,
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
    }),
    acesso() {
      if (this.comissao) {
        return 'COMISSAO';
      }
      if (this.chefia || this.substituicaoChefia) {
        return 'COMUM';
      }
      return null;
    },
  },

  mounted() {
    switch (this.$route.name) {
      case 'MonitoramentoPerfilFiltro':
        this.componente = { nome: 'FiltroBuscaPerfil', titulo: 'Filtros de Busca do Perfil' };
        if (!this.isTutorialFiltroBuscaExibido && this.acesso) {
          this.$store.dispatch('app/showTutorial', { nome: 'MonitoramentoPerfilFiltrosBusca' });
        }
        break;
      case 'MonitoramentoPerfilRelatorio':
        this.componente = { nome: 'RelatorioGerencialPerfil', titulo: 'Relatórios Gerais do Perfil' };
        if (!this.isTutorialRelatoriosGerenciaisExibido && this.acesso) {
          this.$store.dispatch('app/showTutorial', { nome: 'MonitoramentoPerfilRelatoriosGerenciais' });
        }
        break;
      default:
        break;
    }
  },
};
</script>
